import script from "./MultiplicatorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiplicatorInfo.vue?vue&type=script&setup=true&lang=js"

import "./MultiplicatorInfo.vue?vue&type=style&index=0&id=7df369ca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df369ca"]])

export default __exports__